<ion-modal #modal trigger="open-modal" [initialBreakpoint]="0.9">
  <ng-template>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-button color="medium" (click)="cancel()">Cancel</ion-button>
        </ion-buttons>
        <ion-title>{{ ModalTitle }}</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <ion-searchbar
        (ionInput)="handleInput($event)"
        class="ion-padding-horizontal search-input"
        placeholder="Search ...">
      </ion-searchbar>
      <ion-list class="ion-padding-horizontal search-list">
        <ion-row
          *ngFor="let option of searchResults"
          (click)="this.setResult(option)"
          class="ion-padding-vertical name-search-row">
          {{ option.name }}
        </ion-row>
      </ion-list>
    </ion-content>
  </ng-template>
</ion-modal>
